var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1788 2.09346C11.3112 0.922517 9.60365 0.593968 8.344 1.51771L3.10943 5.35639C1.46827 5.75613 0.25 7.2358 0.25 9V17C0.25 19.0711 1.92893 20.75 4 20.75H16C18.0711 20.75 19.75 19.0711 19.75 17V16.1465C20.9043 15.82 21.75 14.7588 21.75 13.5C21.75 12.2412 20.9043 11.18 19.75 10.8535V9C19.75 7.52614 18.8997 6.25087 17.6629 5.63796L16.6426 3.08704C15.9803 1.43144 13.9419 0.834168 12.4909 1.87059L12.1788 2.09346ZM5.79101 5.25H7.75969L10.9569 2.96628C10.5575 2.4526 9.79537 2.31348 9.23104 2.72732L5.79101 5.25ZM13.3627 3.09119C14.0223 2.62009 14.9488 2.89158 15.2499 3.64412L15.8922 5.25H10.3404L13.3627 3.09119ZM18.25 16.25H17C15.4812 16.25 14.25 15.0188 14.25 13.5C14.25 11.9812 15.4812 10.75 17 10.75H18.25V9C18.25 7.75736 17.2426 6.75 16 6.75H4C2.75736 6.75 1.75 7.75736 1.75 9V17C1.75 18.2426 2.75736 19.25 4 19.25H16C17.2426 19.25 18.25 18.2426 18.25 17V16.25ZM17 12.25C16.3096 12.25 15.75 12.8096 15.75 13.5C15.75 14.1904 16.3096 14.75 17 14.75H19C19.6904 14.75 20.25 14.1904 20.25 13.5C20.25 12.8096 19.6904 12.25 19 12.25H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.1ef7f741996f361ed526b8bad2202f26.svg";
export { ForwardRef as ReactComponent };